import type { IconProps } from "./types";

export function Calendar({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 1.09961C16.4971 1.09961 16.9004 1.50294 16.9004 2V3.09961H19C20.5524 3.09961 21.9003 4.30074 21.9004 5.88867V19.1113C21.9003 20.6993 20.5524 21.9004 19 21.9004H5C3.4476 21.9004 2.09973 20.6993 2.09961 19.1113V5.88867C2.09973 4.30074 3.4476 3.09961 5 3.09961H7.09961V2C7.09961 1.50294 7.50294 1.09961 8 1.09961C8.49706 1.09961 8.90039 1.50294 8.90039 2V3.09961H15.0996V2C15.0996 1.50294 15.5029 1.09961 16 1.09961ZM3.90039 10.9004V19.1113C3.90052 19.6096 4.34342 20.0996 5 20.0996H19C19.6566 20.0996 20.0995 19.6096 20.0996 19.1113V10.9004H3.90039ZM5 4.90039C4.34342 4.90039 3.90052 5.39037 3.90039 5.88867V9.09961H20.0996V5.88867C20.0995 5.39037 19.6566 4.90039 19 4.90039H16.9004V6C16.9004 6.49706 16.4971 6.90039 16 6.90039C15.5029 6.90039 15.0996 6.49706 15.0996 6V4.90039H8.90039V6C8.90039 6.49706 8.49706 6.90039 8 6.90039C7.50294 6.90039 7.09961 6.49706 7.09961 6V4.90039H5Z"
        fill={currentColor}
      />
    </svg>
  );
}
